import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import { css, px, remove as removeCss } from '@jd/jmtd-tools/es/css';
import { repeat, take } from '@jd/jmtd-tools/es/generator';
import { SCROLL_CONTENT, TabsScrollContext } from '../Tabs/util';
var ACTIVE_LINE = Symbol('activeLine');
export default function LineTabs(self) {
  var margin = 20;

  var _TabsScrollContext = TabsScrollContext({
    self: self,
    margin: margin,
    optionalScrollButtonWidth: true,
    getTabsWidth: function getTabsWidth() {
      var tabsRef = self.tabsRef,
          tabWidth = self.props.tabWidth;
      var tabsWidth = tabsRef.map(function (node) {
        return node.offsetWidth;
      });

      if (tabWidth === 'fit-content') {
        // 宽度适应内容
        return tabsWidth;
      } // 所有tab宽度一致


      // 所有tab宽度一致
      var itemWidth = Math.max.apply(Math, _toConsumableArray(tabsWidth));
      return _toConsumableArray(take(tabsRef.length, repeat(itemWidth)));
    },
    handleScroll: function handleScroll(_ref) {
      var currentMatch = _ref.currentMatch,
          maxScrollWidth = _ref.maxScrollWidth,
          matchedWidth = _ref.matchedWidth,
          tabsWidth = _ref.tabsWidth;
      var tabsRef = self.tabsRef;
      tabsRef.forEach(function (tab) {
        removeCss(tab, 'width');
      }); // 设置间隔

      // 设置间隔
      if (currentMatch.length === 1) {
        css(tabsRef[0], 'width', px(Math.min(maxScrollWidth, tabsWidth[0])));
      } else if (currentMatch.length < tabsRef.length) {
        var remindExtra = maxScrollWidth - matchedWidth - (currentMatch.length - 1) * margin;
        var itemMargin = Math.round(remindExtra / currentMatch.length);
        currentMatch.forEach(function (index) {
          css(tabsRef[index], 'width', px(tabsWidth[index] + Math.min(remindExtra, itemMargin)));
          remindExtra -= itemMargin;
        });
      } else {
        tabsRef.forEach(function (tab, index) {
          css(tab, 'width', px(tabsWidth[index]));
        });
      }
    },
    callback: function callback() {
      var activeTab = self.activeTab,
          activeLine = self[ACTIVE_LINE]; // 移动底线

      // 移动底线
      if (activeTab) {
        css(activeLine, {
          width: px(activeTab.offsetWidth),
          transform: "translate3d(".concat(px(activeTab.offsetLeft), ",0,0)")
        });
      } else {
        removeCss(activeLine, ['width', 'transform']);
      }
    }
  }),
      _update = _TabsScrollContext.update,
      arrowLeft = _TabsScrollContext.arrowLeft,
      arrowRight = _TabsScrollContext.arrowRight;

  return {
    className: 'jmtd-line-tabs',
    update: function update() {
      _update(self.activeIndex);
    },
    render: function render(tabs) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, arrowLeft, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-tabs-scroll-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-tabs-scroll-content",
        ref: function ref(el) {
          self[SCROLL_CONTENT] = el;
        }
      }, tabs, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-line-tabs-active-line",
        ref: function ref(el) {
          self[ACTIVE_LINE] = el;
        }
      }))), arrowRight, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-tabs-border"
      }));
    }
  };
}